export const loadIntersectionObserverPolyfill = async (): Promise<void> => {
  if (typeof IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
};
